// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //
// 這裡的顏色設定是 mantis 預設主題的顏色設定沒有做任何更動
export default function getShadow(theme, shadow) {
  switch (shadow) {
    case 'secondary':
      return "0 0 0 2px rgba(140, 140, 140, 0.2)";
    case 'error':
      return "0 0 0 2px rgba(255, 77, 79, 0.2)";
    case 'warning':
      return "0 0 0 2px rgba(250, 173, 20, 0.2)";
    case 'info':
      return "0 0 0 2px rgba(19, 194, 194, 0.2)";
    case 'success':
      return "0 0 0 2px rgba(82, 196, 26, 0.2)";
    case 'primaryButton':
      return "0 14px 12px rgba(22, 119, 255, 0.2)";
    case 'secondaryButton':
      return "0 14px 12px rgba(140, 140, 140, 0.2)";
    case 'errorButton':
      return "0 14px 12px rgba(255, 77, 79, 0.2)";
    case 'warningButton':
      return "0 14px 12px rgba(250, 173, 20, 0.2)";
    case 'infoButton':
      return "0 14px 12px rgba(19, 194, 194, 0.2)";
    case 'successButton':
      return "0 14px 12px rgba(82, 196, 26, 0.2)";
    default:
      return "0 0 0 2px rgba(22, 119, 255, 0.2)";
  }
}
